import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=c5ad1d8c&"
import script from "./DocumentsTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsTable.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports